/**
 * Constraint types for gift-giving relationships
 * 0 = CAN (allowed, default)
 * 1 = MUST (required)
 * 2 = CANNOT (forbidden)
 */
export enum Constraint {
  CAN = 0,
  MUST = 1,
  CANNOT = 2,
}

/**
 * Application state containing all data needed for Secret Santa
 */
export interface AppState {
  /** List of participant names */
  names: string[];

  /**
   * Constraint matrix: constraints[i][j] represents constraint from person i to person j
   * Matrix is n x n where n = names.length
   */
  constraints: Constraint[][];

  /** Random seed for deterministic results */
  seed: number;

  /**
   * Metadata field names (e.g., ["email", "phone"])
   * These define what additional data can be attached to each person
   */
  metadataFields: string[];

  /**
   * Metadata values for each person
   * metadata[personIndex][fieldIndex] = value
   * Matrix is n x m where n = names.length, m = metadataFields.length
   */
  metadata: string[][];
}

/**
 * Result of Secret Santa generation
 * Array where result[i] = j means person i gives to person j
 */
export type SecretSantaResult = number[];

/**
 * Error types for Secret Santa generation
 */
export class SecretSantaError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SecretSantaError";
  }
}

export class NoSolutionError extends SecretSantaError {
  constructor(message = "No valid Secret Santa solution exists with given constraints") {
    super(message);
    this.name = "NoSolutionError";
  }
}

export class InvalidStateError extends SecretSantaError {
  constructor(message: string) {
    super(message);
    this.name = "InvalidStateError";
  }
}
